var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup82(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 36,
    viewBox: "0 0 74 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50024 32.5952H34.064L40.3034 28.5582V10.941L2.50024 32.5952Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7555 31.1271L55.3512 6.16992L40.3034 10.941M40.3034 10.941L2.50024 32.5952H34.064L40.3034 28.5582V10.941ZM55.3512 6.16992L52.048 31.1271",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2236 7.63809C61.2236 9.00085 61.765 10.3078 62.7286 11.2714C63.6922 12.235 64.9992 12.7764 66.3619 12.7764C67.7247 12.7764 69.0316 12.235 69.9952 11.2714C70.9589 10.3078 71.5002 9.00085 71.5002 7.63809C71.5002 6.27533 70.9589 4.96839 69.9952 4.00477C69.0316 3.04115 67.7247 2.4998 66.3619 2.4998C64.9992 2.4998 63.6922 3.04115 62.7286 4.00477C61.765 4.96839 61.2236 6.27533 61.2236 7.63809Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup82);
export default __webpack_public_path__ + "static/media/Group 82.4a86607225442f54caf33ea6f14491dd.svg";
export { ForwardRef as ReactComponent };